import React from 'react';

const MachineLearning = () => {
    return (
        <div>
            <h1>MachineLearning page</h1>
        </div>
    );
}

export default MachineLearning;
